import { createContext } from 'react';

const colorModeContext = createContext({ toggleColorMode: () => {} });

export default colorModeContext;
